import '@app/App.css';
import Hamburger from 'hamburger-react'
import { useModelStore } from 'src/store';

interface BurgerMenuProps {
  onToggle: () => void;
  isOpen: boolean;
}

function BurgerMenu({ onToggle, isOpen }: BurgerMenuProps) {
  const workspace = useModelStore(state => state.selectedWorkspace);
  const wsIsDarkColor = useModelStore(state => state.wsIsDarkColor);
  if (!workspace) {
    return null;
  }

  return (
    <div  className={`flex items-center grow rounded-md transition-colors`}>
    <Hamburger 
        size={20} 
        color={wsIsDarkColor 
          ? 'white' 
          : 'black'}
        toggled={isOpen}
        toggle={onToggle}
      />
    </div>
  );
}

export default BurgerMenu;

